import React from 'react';
import styled from '@emotion/styled/macro';
import { LoadingMeter } from '../base';
import * as SectionS from '../claim-details/claim-section.styles';
import { ClaimFinancialSummary } from './claim-financial-summary';
import { ClaimFinancialSummaryData } from './claim-financial-summary.utils';

const Body = styled.div`
    margin: 0 24px;
`;

interface IClaimFinancialsSectionProps {
    /** True while any input to the totals (template, payments, collections, chargemaster) is still loading. */
    loading: boolean;
    financials?: ClaimFinancialSummaryData;
}

/**
 * "Claim Financials" block for the embedded claim panel, between Claim Overview and the services
 * table. While inputs load it shows a loader rather than zeros: a $0.00 tile would assert a result
 * we have not computed (NS-3).
 */
export const ClaimFinancialsSection: React.FC<IClaimFinancialsSectionProps> = ({ loading, financials }) => (
    <SectionS.ClaimSectionBlock>
        <SectionS.ClaimSectionHeader>
            <SectionS.ClaimSectionTitle>Claim Financials</SectionS.ClaimSectionTitle>
        </SectionS.ClaimSectionHeader>
        <Body>{loading || !financials ? <LoadingMeter /> : <ClaimFinancialSummary financials={financials} />}</Body>
    </SectionS.ClaimSectionBlock>
);
